
function InvoicePreview({
  invoiceType,
  customer,
  phone,
  address,
  gstin,
  items = [],
  subTotal,
  gst,
  grandTotal,
  deleteItem,
  amountInWords,
  receivedAmount = 0,
    invoiceNo,
    state,
    city,
    
})  {
  const balance = grandTotal - receivedAmount;
  return (
    <div className="invoice-container">

      <div className="top-section">
        <div>
          <img src="/corealpha.jpeg" alt="Logo" className="invoice-logo" />
          <h2>Corealpha IT Solutions</h2>
          <p>283/63/KA/26 HARCHARANPUR Lucknow</p>
          <p>Phone no. : 9044575846</p>
          <p>Email : infocorealphaitsolutions@gmail.com</p>
          <p>GSTIN : 09BFKPA1457F1ZN</p>
          <p>State: Uttar Pradesh</p>
        </div>

       
      </div>
<div>
             <h3 className="invoiceType">{invoiceType}</h3>
        </div>
      <div className="bill-section">
        
        <div>
          <h3>Bill To</h3>
          <p> Name:{customer}</p>
           <p>Address:{address}</p>
            <p>City: {city}</p>
         <p>  State:{state}</p>
          <p>Contact No. {phone}</p>
          
          <p>GstInvoice:{gstin}</p>
        </div>

        <div>
            <h3>Invoice Details</h3>
        <p>Invoice No:{invoiceNo}</p>
          <p>Date: {new Date().toLocaleDateString()}</p>
          <p>Place of supply: Uttar Pradesh</p>
        </div>
      </div>

      <table className="invoice-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Item</th>
            <th>Qty</th>
            <th>Price</th>
            <th>GST</th>
            <th>Total</th>
            <th className="no-print">Action</th>
          </tr>
        </thead>

        <tbody>
          {items.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item.product}</td>
              <td>{item.qty}</td>
              <td>₹{item.price}</td>
              <td>{item.gst}(18%)</td>
              <td>₹{item.total}</td>
              <td className="no-print">
  <button onClick={() => deleteItem(index)}>Delete</button>
</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="summary-wrapper">

       <div className="amount-words">
  <p><b>Invoice Amount In Words</b></p>
  
  <p>{amountInWords} Rupees only</p>

    
    <div className="bank-details">
      <h3 className="heading">Bank Details</h3>

      <div className="row">
        <span>Bank Name</span>
        <span>Indian Bank</span>
      </div>

      <div className="row">
        <span>Account Name</span>
        <span>Corealpha IT Solutions</span>
      </div>

      <div className="row">
        <span>Account No</span>
        <span>7962863940</span>
      </div>

      <div className="row">
        <span>IFSC Code</span>
        <span>IDIB000L560</span>
      </div>
      <div className="row">
        <h5>PAYMENT QR CODE 
      <p>UPI ID:</p>
      <p>naseebahmadansari43@indianbk</p>
        </h5>
        <div><img src="/core-qr.jpeg" className="Qr-image "/></div>
      </div>
    </div>

</div>
         
        <div className="summary-box">

          <div className="row">
            <span>Sub Total</span>
            <span>₹ {subTotal}</span>
          </div>

         {/* GST SECTION (ONLY FOR TAX INVOICE) */}
{invoiceType === "Tax Invoice" && (
  <>
    <div className="row">
      <span>SGST @9%</span>
      <span>₹ {gst / 2}</span>
    </div>

    <div className="row">
      <span>CGST @9%</span>
      <span>₹ {gst / 2}</span>
    </div>
  </>
)}

          <div className="row total">
            <span>Total</span>
            <span>₹ {grandTotal}</span>
          </div>

           <div className="row">
            <span>Received</span>
            <span> {receivedAmount}</span>
          </div>

          <div className="row">
            <span>Balance</span>
            <span>₹ {balance}</span>
          </div> 
  <div className="footer">
        <p>For: Corealpha IT Solutions</p>
      </div>
        </div>
      </div>
    
       </div>
  
);
}

export default InvoicePreview;